import { useState } from "react";
import { Button } from "../../components/button/button";
import { AiService } from "../../utilities/services/ai-service";
import { createLogger } from "../../utilities/logger";

const log = createLogger("RiskSummaryTool");

const COMPONENT_CLASS = "c-ai-tool";

const AiTool: React.FC = () => {
    const [input, setInput] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [result, setResult] = useState<string>("");

    const handleSubmit = async () => {
        if (!input || input.trim().length === 0) {
            return;
        }

        setLoading(true);
        setResult("");

        try {
            const response = await AiService.riskSummary(input.trim());
            log.info("[AI Tool] Response received");
            setResult(response);
        } catch (error: unknown) {
            log.error("[AI Tool] Error", {
                exception: error,
            });
            const errorMessage = error instanceof Error ? error.message : "Failed to get AI response";
            setResult(`Error: ${errorMessage}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={COMPONENT_CLASS}>
            <h2>AI Risk Summary</h2>
            <p>
                This tool allows you to test the AI Risk Summary endpoint. Enter a
                risk category (e.g., "health-1", "wellness-1", "fitness-1") to get an AI
                summary.
            </p>

            <div className={`${COMPONENT_CLASS}__input`}>
                <label>Risk Category</label>
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Enter health-1, wellness-1, fitness-1, performance"
                />
            </div>

            <div className={`${COMPONENT_CLASS}__actions`}>
                <Button
                    onClick={handleSubmit}
                    buttonText={loading ? "Loading..." : "Risk Summary"}
                    disabled={loading || !input || input.trim().length === 0}
                />
            </div>

            {result && (
                <div className={`${COMPONENT_CLASS}__result`}>
                    <label>Result</label>
                    <pre>{result}</pre>
                </div>
            )}
        </div>
    );
};

export default AiTool;